import { Collapsible as Primitive } from 'radix-ui';

export const Collapsible = Primitive.Root;

export const CollapsibleTrigger = Primitive.Trigger;

export const CollapsibleContent = Primitive.Content;
